import { instance } from './config';

export const getSaleStatsByStatus = (startDate, endDate) => {
   return instance.get('/stats/status', {
      params: {
         startDate: startDate,
         endDate: endDate,
      },
   });
};

export const getSaleStatsByVendor = (startDate, endDate) => {
   return instance.get('/stats/vendor', {
      params: {
         startDate: startDate,
         endDate: endDate,
      },
   });
};
